document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#compra-por-tienda"], a[href="/#compra-por-tienda"]');
  if (!link) return;
  const target = document.getElementById('compra-por-tienda');
  if (!target) return;
  event.preventDefault();
  target.setAttribute('tabindex', '-1');
  target.focus({preventScroll: true});
  target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
});

document.addEventListener('submit', (event) => {
 const form = event.target.closest('form[data-heygo-scoped-brand]');
 if (!form) return;
 event.preventDefault();
 const selected = form.elements.brand_url.value;
 const destination = new URL(selected, location.origin);
 if (destination.origin === location.origin) location.assign(destination.href);
});

function heygoSyncPresentation() {
  for (const picker of document.querySelectorAll('variant-selects, variant-radios')) {
    if (!picker.updateOptions || !picker.updateMasterId || !picker.updateHeyGoPresentation) continue;
    picker.updateOptions(); picker.updateMasterId(); picker.updateHeyGoPresentation();
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', heygoSyncPresentation);
else heygoSyncPresentation();
document.addEventListener('shopify:section:load', heygoSyncPresentation);
